// frontend/src/BlogPostDetail.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getCookie } from './utils';
import './BlogSection.css'; // Reuse the same styles

function BlogPostDetail() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`/api/blog/${id}/`, { credentials: 'include' })
      .then(res => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then(data => setPost(data))
      .catch(err => {
        console.error('Error fetching blog post:', err);
        setError('Failed to load the blog post.');
      });
  }, [id]);

  if (error) return <p>{error}</p>;
  if (!post) return <p>Loading...</p>;

  return (
    <div className="blog-section">
      <div className="blog-post">
        <h2>{post.title}</h2>
        <p>By {post.author_username} on {new Date(post.created_at).toLocaleDateString()}</p>
        {post.image && <img src={post.image} alt={post.title} />}
        <div dangerouslySetInnerHTML={{ __html: post.content }} />
      </div>
    </div>
  );
}

export default BlogPostDetail;

